const Category = ({
	Active = true,
	BulkCopyBatchID = null,
	BulkCopyRecordID = null,
	CategoryID = null,
	Name = '',
	ProductCount = 0,
	Products = [],
	Seller = '',
	SellerID = '',
}) => ({
	Name,
	Active,
	BulkCopyBatchID,
	BulkCopyRecordID,
	CategoryID,
	ProductCount,
	Products,
	Seller,
	SellerID,
});

export default Category;
